import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import DataErrorComponent from './DataErrorComponent';

interface Column {
  columnId: string;
  columnName: string;
  columnType: string;
  isHidden: boolean;
}

interface GridProps {
  podData: any[];
  columnsData: Column[];
}

const GridComponent: React.FC<GridProps> = ({ podData, columnsData }) => {
  const isLoading = false;
  const error = null;
  const columns: GridColDef[] = columnsData
    ? columnsData.map((column) => ({
        field: column.columnId,
        headerName: column.columnName,
        headerClassName: 'grid-columns-header',
        valueFormatter: (params) => {
          return column.columnType === 'DateTime'
            ? dayjs(params?.value).format('DD/MM/YYYY')
            : params?.value;
        },
        flex: 1,
      }))
    : [];

  return (
    <div className="dashboard-pod-control-container">
      {isLoading ? (
        <div className="grid-loader">
          <CircularProgress />
        </div>
      ) : error ? (
        <DataErrorComponent error={error} />
      ) : (
        <DataGrid
          rows={podData}
          density="compact"
          columns={columns}
          getRowId={(row) => row.id}
          sx={{
            '.MuiDataGrid-footerContainer': {
              minHeight: '39px',
            },
          }}
        />
      )}
    </div>
  );
};

export default GridComponent;
